module.exports = __webpack_public_path__ + "static/media/rs.d583be7e.png";